import React from 'react';

const NotFoundPage: React.FC = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      <h1>Página não encontrada / 404</h1>
    </div>
  );
};

export default NotFoundPage;
